<template>
  <b-container>
    <b-modal
      id="newProductModal"
      ref="newProductModal"
      :title="title"
      @hidden="handleHidden"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <avatar />
        <br />
        <b-form-group
          :state="nameState"
          label="Product Name"
          label-for="name-input"
          invalid-feedback="Product name is required"
        >
          <b-form-input id="name-input" v-model="name" :value="name" :state="nameState" requires></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="isNewModal"
          label-for="checkbox-1"
          description="You won't be able to change this after creating the product."
        >
          <b-form-checkbox
            id="checkbox-1"
            v-model="hasApps"
            name="checkbox-1"
          >This product contains multiple apps.</b-form-checkbox>
        </b-form-group>
        <b-form-group
          label-for="checkbox-2"
          description="The product will still be reachable using the URL."
        >
          <b-form-checkbox
            id="checkbox-2"
            v-model="hidden"
            name="checkbox-2"
          >Hide product from start page.</b-form-checkbox>
        </b-form-group>
      </form>
    </b-modal>
  </b-container>
</template>

<script>
import Avatar from './Avatar';
import axios from 'axios';

export default {
  components: {
    Avatar
  },
  data() {
    return {
      title: 'Create a new Product',
      hasApps: true,
      name: '',
      nameState: null,
      isNewModal: true,
      productId: '',
      hidden: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.fullPath === '/new') {
      next();
    } else {
      axios.get(process.env.VUE_APP_BASE_URL + to.fullPath).then(response => {
        next(vm => {
          vm.setData(response);
        });
      });
    }
  },
  methods: {
    setData(product) {
      this.hasApps = product.data.hasApps;
      this.name = product.data.name;
      this.hidden = product.data.hidden;
      this.isNewModal = false;
      this.title = 'Edit Product';
      this.productId = product.data.url;
      this.$nextTick(() => {
        document.querySelector('img.card-img.avatar').src = product.data.icon;
      });
    },
    showModal() {
      this.$refs['newProductModal'].show();
    },
    closeModal() {
      this.$refs['newProductModal'].hide();
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid ? 'valid' : 'invalid';
      return valid;
    },
    handleHidden() {
      this.$router.back();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      let imageUrl = document.querySelector('img.card-img.avatar').src;
      if (this.isNewModal) {
        axios
          .post(process.env.VUE_APP_BASE_URL + '/', {
            name: this.name,
            hasApps: this.hasApps,
            iconUrl: imageUrl,
            hidden: this.hidden
          })
          .then(() => {})
          .catch(() => {});
      } else {
        axios
          .put(process.env.VUE_APP_BASE_URL + '/' + this.productId, {
            name: this.name,
            iconUrl: imageUrl,
            hidden: this.hidden
          })
          .then(() => {})
          .catch(() => {});
      }

      this.$nextTick(() => {
        this.closeModal();
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.showModal();
    });
  }
};
</script>